import { Link } from "react-router-dom";
import { Feather, Instagram, Youtube, Twitter, Facebook } from "lucide-react";
import { NAV_LINKS } from "@/data/content";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "#" },
  { icon: Youtube, label: "YouTube", href: "#" },
  { icon: Twitter, label: "Twitter", href: "#" },
  { icon: Facebook, label: "Facebook", href: "#" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-forest text-cream">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="flex flex-col gap-12 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-cream text-forest">
                <Feather size={16} />
              </span>
              <span className="font-serif text-xl font-semibold">The Cap Chronicles</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-cream/70">
              A journey of courage, imagination, and discovering the extraordinary hidden inside ordinary moments.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  data-testid={`social-${s.label.toLowerCase()}`}
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/80 transition-colors duration-300 hover:border-gold hover:text-gold"
                >
                  <s.icon size={16} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Explore</p>
              <ul className="mt-4 space-y-2.5">
                {NAV_LINKS.slice(1, 5).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-sm text-cream/75 transition-colors hover:text-cream">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Join In</p>
              <ul className="mt-4 space-y-2.5">
                {NAV_LINKS.slice(5).map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-link-${l.label.toLowerCase()}`} className="text-sm text-cream/75 transition-colors hover:text-cream">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Legal</p>
              <ul className="mt-4 space-y-2.5">
                <li><a href="#" data-testid="footer-privacy-link" className="text-sm text-cream/75 transition-colors hover:text-cream">Privacy</a></li>
                <li><Link to="/contact" data-testid="footer-contact-link" className="text-sm text-cream/75 transition-colors hover:text-cream">Contact</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-cream/15 pt-6 text-xs text-cream/50 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} The Cap Chronicles. All stories reserved.</p>
          <p className="font-serif italic text-cream/60">The magic was never the ball. It was you.</p>
        </div>
      </div>
    </footer>
  );
}
